module.exports = __webpack_public_path__ + "static/img/erwm.6b29440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicClass/erwm.png
// module id = gswk
// module chunks = 23